import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import { useEffect, useState } from 'react';
import layoutConf from "../../config/layoutConf";
import { useTranslation } from 'react-i18next';

function TkProcessFactorCost(props) {

    const [height, setHeight] = useState(0);

    const { t } = useTranslation();

    const handleResize = () => {

        setHeight(document.documentElement.offsetHeight - 96);

    };

    useEffect(() => {


        window.addEventListener('resize', handleResize);
        handleResize();

        return (() => {
            window.removeEventListener('resize', handleResize);
        });


    }, []);

    return (<BasicCrudScreenType id="TkProcessFactorCost" table="TkProcessFactorCost" view="TkVwProcessFactorCost" headerTitle={t("term.factor")} buttonsInFrontOfSearch noCreate noDelete />)


    // return (

    //     <div style={{ height: height }} >

    //         <ReflexContainer orientation="vertical">

    //             <ReflexElement flex={0.5}>

    //                 <BasicCrudScreenType id="TkProcessFactorCost" table="TkProcessFactorCost" view="TkVwProcessFactorCost" headerTitle={t("term.factor")} buttonsInFrontOfSearch />

    //             </ReflexElement>

    //             <ReflexSplitter style={{ width: layoutConf.reflex.splitterWidth }} />

    //             <ReflexElement>

    //                 <ReflexContainer orientation="horizontal">

    //                     <ReflexElement flex={0.5}>

    //                         <BasicCrudScreenType id="TkMstFactor" table="TkMstFactor" view="TkMstFactor" headerTitle={t("term.auto")} buttonsInFrontOfSearch />


    //                     </ReflexElement>

    //                     <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />

    //                     <ReflexElement>
    //                         <div>

    //                             <BasicCrudScreenType id="TkProcessFormulaCost" table="TkProcessFormulaCost" view="TkVwProcessFormulaCost" headerTitle={t("term.formula")} buttonsInFrontOfSearch />

    //                         </div>

    //                     </ReflexElement>

    //                 </ReflexContainer>

    //             </ReflexElement>

    //         </ReflexContainer>

    //     </div>

    // );

}

export default TkProcessFactorCost;
